export { Typography as Typo } from '@yanolja-rnd/ya-com-core';
